import { httpRequest } from '@/request/utils/httprequest.js'
import baseUrl from '@/request/base.js'
import { baseconfig, rsaBasicModuleConfig } from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import store from '@/store'
import qs from 'qs'

//国家奖扶-填报申报--HYT
export const policydeclarationinfoModule = {
    // 国家奖扶-填报申报--HYT
    async policydeclarationinfo(applyhousejson, applyuserjson, applyusergalleryjson, policy_measure_id, audit_status, mark, original_value_json) {
        const adminToken = store.getters.adminID
        var paras = {
            applyhousejson: applyhousejson,
            applyuserjson: applyuserjson,
            applyusergalleryjson: applyusergalleryjson,
            policy_measure_id: policy_measure_id,
            audit_status: audit_status,
            mark: mark,
            original_value_json: original_value_json,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + audit_status + 'dasdfe', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'policydeclarationinfo', 'put', qs.stringify(paras), null)
    },

    // 政策措施下拉框 HYT
    // /policymeasureinfoalllist
    async policymeasureinfoalllist() {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~H6q5f4sd', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'policymeasureinfoalllist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign), 'get', null, null)
    },

    // 政策申报详情 HYT
    // /policydeclarationinfomodel
    async policydeclarationinfomodel(certificate_no, policy_measure_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~165asDI9', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'policydeclarationinfomodel?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&certificate_no=' + certificate_no + '&policy_measure_id=' + policy_measure_id, 'get', null, null)
    },
    // 政策申报详情通用 HYT
    async policydeclarationinfomodelv2(apply_record_id, mark) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_id) + '~1613ASDI9', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'policydeclarationinfomodelv2?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&apply_record_id=' + apply_record_id + '&mark=' + mark, 'get', null, null)
    },

    //受审登记列表
    async acceptapplylist(page, page_size, key_words, id_number, policy_measure_id,account_nature, year, accept_region_level,accept_region_id,audit_status) {
        const adminToken = store.getters.adminID
        var paras = {
            page: page,
            page_size: page_size,
            key_words: key_words,
            id_number: id_number,
            policy_measure_id: policy_measure_id,
            account_nature: account_nature,
            year: year,
            accept_region_level: accept_region_level,
            accept_region_id: accept_region_id,
            audit_status: audit_status,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + year + accept_region_id + 'fasjkfjd', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'acceptapplylist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + paras.key_words + '&id_number=' + paras.id_number + '&policy_measure_id=' + paras.policy_measure_id + '&account_nature=' + paras.account_nature + '&year=' + paras.year + '&accept_region_level=' + paras.accept_region_level + '&accept_region_id=' + paras.accept_region_id + '&audit_status=' + paras.audit_status, 'get', null, null)
    },

}

// 窗口受理-申请未通过-申请人列表--CGX
export const applyauditfaileduserlistModule = {

    // 窗口受理-申请未通过-申请人列表--CGX
    async applyauditfaileduserlist(page, page_size, key_words, id_number, policy_measure_id, region_level, region_id) {
        const adminToken = store.getters.adminID
        var paras = {
            page: page,
            page_size: page_size,
            key_words: key_words,
            id_number: id_number,
            policy_measure_id: policy_measure_id,
            region_level: region_level,
            region_id: region_id,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + region_level + region_id + 'dg@srti', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyauditfaileduserlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + paras.key_words + '&id_number=' + paras.id_number + '&policy_measure_id=' + paras.policy_measure_id + '&region_level=' + paras.region_level + '&region_id=' + paras.region_id, 'get', null, null)
    },

}

export const applyAuditModule = {
        //申报审核-批量审核--CGX
        async applybatchaudit(apply_record_ids, user_ids, policy_measure_id, is_audit_pass, no_pass_reason_id, no_pass_reason, mark) {
            const adminToken = store.getters.adminID
            var paras = {
                policy_measure_id: policy_measure_id,
                user_ids: user_ids,
                apply_record_ids: apply_record_ids,
                is_audit_pass: is_audit_pass,
                no_pass_reason_id: no_pass_reason_id,
                no_pass_reason: no_pass_reason,
                mark: mark,
                timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
                _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_ids) + String(user_ids) + String(policy_measure_id) + String(is_audit_pass) + 'sdajfkj', rsaBasicModuleConfig.clientPrivateKey),
            }
            return await httpRequest(baseUrl.basic + 'applybatchaudit', 'post', qs.stringify(paras), null)
        },

            //申报审核-批量修改公示状态--CGX
    async applybatcheditpublicitystatus(apply_record_ids, user_ids, policy_measure_id, gallery_json, publicity_status) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            user_ids: user_ids,
            apply_record_ids: apply_record_ids,
            gallery_json: gallery_json,
            publicity_status: publicity_status,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_ids) + String(user_ids) + String(policy_measure_id) + String(publicity_status) + 'dfsnkj', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applybatcheditpublicitystatus', 'post', qs.stringify(paras), null)
    },

            //申报审核-重审--CGX
    async applyrepeataudit(apply_record_id, user_id, policy_measure_id, is_audit_pass, no_pass_reason_id, no_pass_reason) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_id: policy_measure_id,
            user_id: user_id,
            apply_record_id: apply_record_id,
            is_audit_pass: is_audit_pass,
            no_pass_reason_id: no_pass_reason_id,
            no_pass_reason: no_pass_reason,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_id) + String(user_id) + String(policy_measure_id) + String(is_audit_pass) + 'fmwkjkrew', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyrepeataudit', 'post', qs.stringify(paras), null)
    },

        //申报审核-批量提交审核--CGX
        async applybatchsubmitforapprocal(apply_record_ids, user_ids, policy_measure_id, mark) {
            const adminToken = store.getters.adminID
            var paras = {
                policy_measure_id: policy_measure_id,
                user_ids: user_ids,
                apply_record_ids: apply_record_ids,
                mark: mark,
                timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
                _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_ids) + String(user_ids) + String(policy_measure_id) + String(mark) + 'fsmkfs', rsaBasicModuleConfig.clientPrivateKey),
            }
            return await httpRequest(baseUrl.basic + 'applybatchsubmitforapprocal', 'post', qs.stringify(paras), null)
        },


    // 申报审核-批量审核--CGX
    async applybatchapprove(mark, type, policy_measure_ids, apply_record_ids, user_ids, policy_measure_id, is_approve_pass, approve_opinion_id, approve_opinion) {
        const adminToken = store.getters.adminID
        var paras = {
            mark: mark,
            type: type,
            policy_measure_ids: policy_measure_ids,
            policy_measure_id: policy_measure_id,
            user_ids: user_ids,
            apply_record_ids: apply_record_ids,
            is_approve_pass: is_approve_pass,
            approve_opinion_id: approve_opinion_id,
            approve_opinion: approve_opinion,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(mark) + String(type) + String(is_approve_pass) + 'GKRO%sdaj', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applybatchapprove', 'post', qs.stringify(paras), null)
    },
}


// 村级审核
export const villageApplyAuditModule = {
    // 国家特扶-窗口受理-国家特扶-申请未通过申请人列表
    async applyauditvillage1userlist(page, page_size, key_words, id_number, policy_measure_id, region_level, region_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + policy_measure_id + 'dfms2klkl', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyauditvillage1userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&id_number=' + id_number + '&policy_measure_id=' + policy_measure_id + '&region_level=' + region_level + '&region_id=' + region_id, 'get', null, null)
    },

    // 申报审核-村级待提交-申请人列表--CGX
    async applyauditvillage2userlist(page, page_size, policy_measure_id, key_words, region_level, region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dfsmkfj', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyauditvillage2userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },

    // 申报审核-村级待审核-申请人列表--CGX
    async applyauditvillage3userlist(page, page_size, policy_measure_id, key_words, region_level, region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dfnsjfsban', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyauditvillage3userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },

    // 申报审核-村级驳回待审-申请人列表--CGX
    async applyauditvillage4userlist(page, page_size, policy_measure_id, key_words, region_level, region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dg@srti', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyauditvillage4userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },
}

// 乡级审核
export const townApplyAuditModule = {

    // 申报审核-乡级待审核-申请人列表--CGX
    async applyaudit1userlist(page, page_size, key_words, policy_measure_id, region_level, region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + 'dfms2klkl', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit1userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },

    // 申报审核-乡级待提交-申请人列表--CGX
    async applyaudit2userlist(page, page_size, policy_measure_id, key_words, region_level, region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dfsmkfj', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit2userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },

    // 申报审核-乡级待审核-申请人列表--CGX
    async applyaudit3userlist(page, page_size, policy_measure_id, key_words, region_level, region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dfnsjfsban', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit3userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },

    // 申报审核-乡级驳回待审-申请人列表--CGX
    async applyaudit4userlist(page, page_size, policy_measure_id, key_words, region_level, region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dg@srti', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit4userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },
}

// 区级审核
export const districtApplyAuditModule = {
    // 申报审核-区级待审核-申请人列表--CGX
    async applyaudit5userlist(page, page_size, key_words, policy_measure_id, region_level, region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + 'dfms2klkl', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit5userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },
    // 申报审核-区级待公示-申请人列表--CGX
    async applyaudit6userlist(page, page_size, policy_measure_id, key_words, region_level, region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dfsmkfj', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit6userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },

    // 申报审核-区级待审核-申请人列表--CGX
    async applyaudit7userlist(page, page_size, policy_measure_id, key_words, region_level, region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dfnsjfsban', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit7userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },

    // 申报审核-区级驳回待审-申请人列表--CGX
    async applyaudit8userlist(page, page_size, policy_measure_id, key_words, region_level, region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(region_level) + String(region_id) + 'dg@srti', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyaudit8userlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&region_level=' + region_level + '&region_id=' + region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },

    // 申报审核-已完成-申请人列表--CGX
    async applyauditfinishuserlist(page, page_size, policy_measure_id, key_words, account_nature, year, enjoy_census_region_level, enjoy_census_region_id, current_census_region_level, current_census_region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(account_nature) + String(year) + String(enjoy_census_region_id) + String(current_census_region_id) + 'dfmskjjdis', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applyauditfinishuserlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&account_nature=' + account_nature + '&year=' + year + '&enjoy_census_region_level=' + enjoy_census_region_level + '&enjoy_census_region_id=' + enjoy_census_region_id + '&current_census_region_level=' + current_census_region_level + '&current_census_region_id=' + current_census_region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
    },

        // 导出/auditlistword
        async auditlistword(policy_measure_id,key_words,account_nature,year,enjoy_census_region_level,enjoy_census_region_id,current_census_region_level,current_census_region_id,id_number) {
            const adminToken = store.getters.adminID
            var paras = {
                timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
                _sign: rsa.signString(baseconfig.v + adminToken + '~cv1QYXCRIPi',rsaBasicModuleConfig.clientPrivateKey),
            }
            return await httpRequest(baseUrl.basic + 'auditlistword?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign)  + '&key_words=' + key_words + '&account_nature=' + account_nature + '&year=' + year+ '&enjoy_census_region_level=' + enjoy_census_region_level+ '&enjoy_census_region_id=' + enjoy_census_region_id+ '&current_census_region_level=' + current_census_region_level+ '&current_census_region_id=' + current_census_region_id + '&policy_measure_id=' + policy_measure_id + '&id_number=' + id_number, 'get', null, null)
        },

}



//公式图集
export const applypublicitygalleryinfolistModule = {

    // /applypublicitygalleryinfolist 公式图集
    async applypublicitygalleryinfolist(page, pagesize, apply_record_id, gallery_type) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + "~A6564d", rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'applypublicitygalleryinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&apply_record_id=' + apply_record_id + '&gallery_type=' + gallery_type, 'get', null, null)
    },
}


//信息查询-申报审核查询--CGX
export const queryapplyauditModule = {
    // 信息查询-申报审核查询--CGX
    async queryapplyauditlist(page, page_size, key_words, policy_measure_id, account_nature, year, enjoy_census_region_level, enjoy_census_region_id, audit_status, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(account_nature) + String(year) + String(enjoy_census_region_id) + 'dfmalka', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'queryapplyauditlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&page_size=' + page_size + '&key_words=' + key_words + '&policy_measure_id=' + policy_measure_id + '&account_nature=' + account_nature + '&year=' + year + '&enjoy_census_region_level=' + enjoy_census_region_level + '&enjoy_census_region_id=' + enjoy_census_region_id + '&audit_status=' + audit_status + '&id_number=' + id_number, 'get', null, null)
    },
}

//信息查询-年审审核查询 CGX
export const queryrewardauditModule = {
    // 信息查询-年审审核查询 CGX
    async queryrewardauditlist(page, pagesize, key_words, policy_measure_id, account_nature, year, enjoy_census_region_level, enjoy_census_region_id, audit_status, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~dfmsklf', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'queryrewardauditlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&key_words=' + key_words + '&policy_measure_id=' + policy_measure_id + '&account_nature=' + account_nature + '&year=' + year + '&enjoy_census_region_level=' + enjoy_census_region_level + '&enjoy_census_region_id=' + enjoy_census_region_id + '&audit_status=' + audit_status + '&id_number=' + id_number, 'get', null, null)
    },
}

//信息查询-扶助对象查询 CGX
export const queryrewardrecordinfolistModule = {
    // /queryrewardrecordinfolist
    async queryrewardrecordinfolist(page, pagesize, key_words, certificate_no, policy_measure_id, account_nature, year, enjoy_census_region_level, enjoy_census_region_id) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~sfankj', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'queryrewardrecordinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&key_words=' + key_words + '&policy_measure_id=' + policy_measure_id + '&account_nature=' + account_nature + '&year=' + year + '&enjoy_census_region_level=' + enjoy_census_region_level + '&enjoy_census_region_id=' + enjoy_census_region_id + '&certificate_no=' + certificate_no, 'get', null, null)
    },
}

//信息查询-退出对象查询 CGX
export const queryrewardlogoutModule = {
    // 信息查询-退出对象查询 CGX
    // //queryrewardlogoutlist
    async queryrewardlogoutlist(page, pagesize, key_words, policy_measure_id, year, enjoy_census_region_level, enjoy_census_region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + 'fkkkkk', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'queryrewardlogoutlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&key_words=' + key_words + '&policy_measure_id=' + policy_measure_id + '&year=' + year + '&enjoy_census_region_level=' + enjoy_census_region_level + '&enjoy_census_region_id=' + enjoy_census_region_id + '&id_number=' + id_number, 'get', null, null)
    },
}


export const logoutRewardFileModel = {
    // 退出对象列表 HYT
    async logoutrewardrecordinfolist(page, pagesize, policy_measure_id, key_words, account_nature, year, enjoy_census_region_level, enjoy_census_region_id, current_census_region_level, current_census_region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~34CFD4d', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'logoutrewardrecordinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&key_words=' + key_words + '&policy_measure_id=' + policy_measure_id + '&account_nature=' + account_nature + '&year=' + year + '&enjoy_census_region_level=' + enjoy_census_region_level + '&enjoy_census_region_id=' + enjoy_census_region_id + '&current_census_region_level=' + current_census_region_level + '&current_census_region_id=' + current_census_region_id + '&id_number=' + id_number, 'get', null, null)
    },

    //城镇奖扶-扶助对象退出/恢复 --HYT
    async recoverrewardrecordinfo(reward_record_id, is_person_logout, person_logout_reason_id, person_logout_reason_remark, census_emigration_place) {
        const adminToken = store.getters.adminID
        var paras = {
            reward_record_id: reward_record_id,
            is_person_logout: is_person_logout,
            person_logout_reason_id: person_logout_reason_id,
            person_logout_reason_remark: person_logout_reason_remark,
            census_emigration_place: census_emigration_place,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(reward_record_id) + '~AS651324', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'recoverrewardrecordinfo', 'post', qs.stringify(paras), null)
    },
}

// 迁出
export const moveoutrewardrecordinfolistModel = {

    // 迁出列表 HYT
    async moveoutrewardrecordinfolist(page, pagesize, key_words, account_nature, enjoy_census_region_level, enjoy_census_region_id, id_number,policy_measure_id=1) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~34Casd4d', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'moveoutrewardrecordinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&key_words=' + key_words + '&account_nature=' + account_nature + '&enjoy_census_region_level=' + enjoy_census_region_level + '&enjoy_census_region_id=' + enjoy_census_region_id + '&id_number=' + id_number + '&policy_measure_id=' + policy_measure_id, 'get', null, null)
    },

    //  档案管理-迁出管理-迁出/区域调整--CGX
    // /censuschangesapply
    async censuschangesapply(reward_record_ids, policy_measure_ids, reward_user_ids, old_census_region_id, new_census_region_id, move_out_type) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_ids: policy_measure_ids,
            reward_user_ids: reward_user_ids,
            reward_record_ids: reward_record_ids,
            old_census_region_id: old_census_region_id,
            new_census_region_id: new_census_region_id,
            move_out_type: move_out_type,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(reward_record_ids) + String(policy_measure_ids) + String(reward_user_ids) + String(old_census_region_id) + String(new_census_region_id) + String(move_out_type) + 'dfsmk', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'censuschangesapply', 'post', qs.stringify(paras), null)
    },
}
// 迁入
export const moveinrewardrecordinfolistModel = {
    // 迁入列表 HYT
    async moveinrewardrecordinfolist(page, pagesize, key_words, year, audit_status, enjoy_census_region_level, enjoy_census_region_id, id_number,policy_measure_id = 1) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~3sd45d4d', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'moveinrewardrecordinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&year=' + year + '&key_words=' + key_words + '&audit_status=' + audit_status + '&enjoy_census_region_level=' + enjoy_census_region_level + '&enjoy_census_region_id=' + enjoy_census_region_id + '&id_number=' + id_number + '&policy_measure_id=' + policy_measure_id, 'get', null, null)
    },

    //  迁入受理审核--HYT
    async censuschangesaudit(census_changes_record_ids, audit_status, no_pass_reason_id, no_pass_reason) {
        const adminToken = store.getters.adminID
        var paras = {
            census_changes_record_ids: census_changes_record_ids,
            audit_status: audit_status,
            no_pass_reason_id: no_pass_reason_id,
            no_pass_reason: no_pass_reason,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            // census_changes_record_ids + audit_status + SADF11 
            _sign: rsa.signString(baseconfig.v + adminToken + String(census_changes_record_ids) + String(audit_status) + 'SADF11', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'censuschangesaudit', 'post', qs.stringify(paras), null)
    },
}

export const rewardFileModel = {
    // 扶助对象列表 HYT
    async rewardrecordinfolist(page, pagesize, apply_class, policy_measure_id, key_words, account_nature, year, enjoy_census_region_level, enjoy_census_region_id, current_census_region_level, current_census_region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + '~34CFD4d', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'rewardrecordinfolist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) + '&page=' + page + '&pagesize=' + pagesize + '&key_words=' + key_words + '&apply_class=' + apply_class + '&policy_measure_id=' + policy_measure_id + '&account_nature=' + account_nature + '&year=' + year + '&enjoy_census_region_level=' + enjoy_census_region_level + '&enjoy_census_region_id=' + enjoy_census_region_id + '&current_census_region_level=' + current_census_region_level + '&current_census_region_id=' + current_census_region_id + '&id_number=' + id_number, 'get', null, null)
    },
}


// // 年审审核
export const rewardannualreviewuserlistModule = {

    // /rewardannualreviewuserlist 年审审核-申请人列表--CGX
    async rewardannualreviewuserlist(page, page_size, key_words, policy_measure_id, account_nature, year, audit_status, age_range_type, enjoy_census_region_level, enjoy_census_region_id, current_census_region_level, current_census_region_id, id_number) {
        const adminToken = store.getters.adminID
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(account_nature) + String(year) + String(age_range_type) + String(enjoy_census_region_id) + String(current_census_region_id) + 'sfma#dsfnj', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'rewardannualreviewuserlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) +
            '&page=' + page + '&page_size=' + page_size +
            '&key_words=' + key_words + '&policy_measure_id=' + policy_measure_id
            + '&account_nature=' + account_nature + '&year=' + year + '&audit_status=' + audit_status
            + '&age_range_type=' + age_range_type + '&enjoy_census_region_level=' + enjoy_census_region_level
            + '&enjoy_census_region_id=' + enjoy_census_region_id + '&current_census_region_level=' + current_census_region_level
            + '&current_census_region_id=' + current_census_region_id + '&id_number=' + id_number
            , 'get', null, null)
    },

    // 年审审核-批量审核--CGX
    // /rewardannualreviewbatchaudit
    async rewardannualreviewbatchaudit(apply_record_ids, user_ids, policy_measure_ids, is_audit_pass, no_pass_reason_id, audit_year, audit_time) {
        const adminToken = store.getters.adminID
        var paras = {
            policy_measure_ids: policy_measure_ids,
            user_ids: user_ids,
            apply_record_ids: apply_record_ids,
            is_audit_pass: is_audit_pass,
            no_pass_reason_id: no_pass_reason_id,
            audit_year: audit_year,
            audit_time: audit_time,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()), rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(apply_record_ids) + String(user_ids) + String(policy_measure_ids) + String(is_audit_pass) + String(no_pass_reason_id) + 'DFjdfs', rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'rewardannualreviewbatchaudit', 'post', qs.stringify(paras), null)
    },

    //国家特扶-年审审核-年审未通过-申请人列表--CGX
    async rewardannualreviewfaileduserlist(page,page_size,key_words,policy_measure_id,account_nature,year,enjoy_census_region_level,enjoy_census_region_id,current_census_region_level,current_census_region_id,id_number) {
        const adminToken = store.getters.adminID
        // （v + AdminToken +policy_measure_id+account_nature+year+age_range_type+enjoy_census_region_id+current_census_region_id+ sfma#dsfnj ）
        var paras = {
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(policy_measure_id) + String(account_nature) + String(year) + String(enjoy_census_region_id)+ String(current_census_region_id) + 'sfmdfsn',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'rewardannualreviewfaileduserlist?timestamp=' + encodeURIComponent(paras.timestamp) + '&_sign=' + encodeURIComponent(paras._sign) +
         '&page=' + page + '&page_size=' + page_size  +
          '&key_words=' + key_words+'&policy_measure_id=' + policy_measure_id
           + '&account_nature=' + account_nature + '&year=' + year+'&enjoy_census_region_level=' + enjoy_census_region_level
           + '&enjoy_census_region_id=' + enjoy_census_region_id + '&current_census_region_level=' + current_census_region_level
           + '&current_census_region_id=' + current_census_region_id + '&id_number=' + id_number
            , 'get', null, null)
    },
    
    // 国家特扶-年审审核-年审未通过-区级批量审核--HYT
    async rewardannualreviewbatchauditdistrict(reward_audit_record_ids,is_audit_pass,no_pass_reason_id,audit_year,audit_time) {
        const adminToken = store.getters.adminID
        var paras = {
            reward_audit_record_ids: reward_audit_record_ids,
            is_audit_pass: is_audit_pass,
            no_pass_reason_id:no_pass_reason_id,
            audit_year: audit_year,
            audit_time:audit_time,
            timestamp: rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey),
            _sign: rsa.signString(baseconfig.v + adminToken + String(reward_audit_record_ids ) + String(is_audit_pass ) + String(no_pass_reason_id) + 'Dasd123Fjdfs',rsaBasicModuleConfig.clientPrivateKey),
        }
        return await httpRequest(baseUrl.basic + 'rewardannualreviewbatchauditdistrict', 'post', qs.stringify(paras), null)
    },
}
